module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAAgUlEQVQoU4XOPQ4BARCG4WcPItEoJAincQatQjZKjSjUerdQu4GfgrgGpcjIrMiG7DSTmbzvl6/ABFvcNc+4wB4ttBv4ORYhxJxy9/5IJZYYVUJwFzzRrUlTrBFh528huCseGKY0wwr9qkVdCO6GI3bYYJD3O+OXEP9DpnYy4NPyBagsFIueKdx2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_active/unfold.png
// module id = qwgT
// module chunks = 1